export const MAX_CRITERIA = 10;
export const NAME_MAX = 255;

export interface EditableCriterion {
  key: string;
  name: string;
  rubric: string;
  score_type: string;
  weight: number;
  order_index: number;
  is_required: boolean;
  pass_threshold: number | null;
  metadata: Record<string, unknown> | null;
}

export interface EditState {
  notes: string;
  criteria: EditableCriterion[];
}
